import {
  PublicClientApplication,
  type Configuration,
  LogLevel,
} from '@azure/msal-browser';

const clientId = import.meta.env.VITE_AZURE_CLIENT_ID;
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID;
const redirectUri =
  import.meta.env.VITE_AZURE_REDIRECT_URI ??
  (typeof window !== 'undefined' ? window.location.origin : '');

const msalConfiguration: Configuration = {
  auth: {
    clientId: clientId ?? '',
    authority: `https://login.microsoftonline.com/${tenantId ?? ''}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error('[MSAL]', message);
        if (level === LogLevel.Warning) console.warn('[MSAL]', message);
      },
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfiguration);

// Microsoft Graph scopes only — no custom API scope. Matches Reporting.
// We use the ID token (audience = client_id) as our bearer token.
export const LOGIN_SCOPES = ['openid', 'profile', 'email'];
